import React from 'react';
import Form from '../../../components/common/Form';
import {NavLink} from 'react-router-dom';

let postTypes = ["auto", "custom", "scheduled"];
postTypes["auto"] = "fas fa-sync-alt m-xs-b";
postTypes["custom"] = "fas fa-star m-xs-b";
postTypes["scheduled"] = "fas fa-calendar-check m-xs-b";

class LatestPost extends Form {
    constructor(props) {
        super(props);
        this.state = {
            latest_posts: this.props.latest_posts || [],
            errors: {}
        };
    }

    componentDidUpdate = () => {
        if (this.state.latest_posts !== this.props.latest_posts) {
            this.setState({latest_posts: this.props.latest_posts || []});
        }
    }

    render() {
        const {latest_posts} = this.state;

        return (
            <div className="dash-panel latest-post">
                <p className="m-m-b">Latest Post</p>
                {/*{console.log('latest_posts: ', latest_posts)}*/}
                {latest_posts && latest_posts.map((post, index) =>
                    <div key={index} className="row">
                        <div className="col-xs-3 badge">
                            <span className={postTypes[post.type ? post.type : "auto"]}></span>
                            <p className="text-bold">20/09</p>
                            <label className="text-center">10:36PM</label>
                        </div>
                        <div className="col-xs-9 latest-post-link">
                            <a target="_blank" className="m-sm-b" href={post.link}><p
                                className="text-bold">{post.post}</p></a>
                            <span>Sent at:<br/> {post.sent_at}</span>
                        </div>
                    </div>
                )}
                <NavLink to="/my-campaigns" className="text-italic">View all posts</NavLink>
            </div>
        )
    }
}

export default LatestPost